export function formatPercent (value: number): string {
    return value + ' %';
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/format-percent.ts